module.exports = __webpack_public_path__ + "img/team_1.3e41b152.jpg";